import Vue from 'vue';
import Vuex from 'vuex';

import { tag } from './modules/tag';
import { drop } from './modules/drop';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    tag,
    drop,
  },
});
